import type { BusinessProfileFields as Fields } from '@repo/api-contracts';
import { type ReactElement, useEffect, useRef, useState } from 'react';
import {
  BusinessProfileFields,
  useBusinessProfileQuery,
  useCheckBusinessNumber,
} from '@/entities/user';
import { Button } from '@/shared/ui';
import { useSaveBusinessProfile } from '../model/use-save-business-profile';
export const BusinessProfileForm = (): ReactElement => {
  const query = useBusinessProfileQuery();
  const [values, setValues] = useState({
    businessNumber: '',
    companyName: '',
    representativeName: '',
    address: '',
    businessType: '',
    businessItem: '',
    invoiceEmail: '',
    contactName: '',
  });
  const dirty = useRef(false);
  const save = useSaveBusinessProfile();
  const business = useCheckBusinessNumber(values.businessNumber);
  useEffect(() => {
    if (query.data && !dirty.current) {
      const { updatedAt: _updatedAt, ...fields } = query.data;
      setValues({ ...fields, contactName: fields.contactName ?? '' });
    }
  }, [query.data]);
  if (query.isPending) return <p role="status">사업자 정보를 불러오는 중입니다.</p>;
  if (query.isError)
    return (
      <div role="alert">
        <p>사업자 정보를 불러오지 못했습니다.</p>
        <Button
          onClick={() => {
            void query.refetch();
          }}
        >
          다시 시도
        </Button>
      </div>
    );
  const change = (key: keyof Fields, value: string) => {
    dirty.current = true;
    setValues((previous) => ({ ...previous, [key]: value }));
  };
  return (
    <form
      aria-label="사업자 정보"
      noValidate
      className="flex flex-col gap-5"
      onSubmit={(event) => {
        event.preventDefault();
        if (!business.isPending && business.state !== 'CLOSED')
          void save.submit({ ...values, contactName: values.contactName.trim() || null });
      }}
    >
      <fieldset disabled={save.isPending}>
        <BusinessProfileFields
          values={values}
          errors={save.errors}
          onChange={change}
          onCheck={() => {
            void business.check();
          }}
          businessState={business.state}
          isChecking={business.isPending}
        />
      </fieldset>
      <Button
        type="submit"
        disabled={save.isPending || business.isPending || business.state === 'CLOSED'}
      >
        저장
      </Button>
      {save.formError ? <p role="alert">{save.formError}</p> : null}
      {save.isSaved ? <p role="status">사업자 정보를 저장했습니다.</p> : null}
    </form>
  );
};
